import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'

import sendMessageWPP from '../services/sendMessageWPP'
import WhatsAppIcon from '../assets/images/whatsapp-icon.png'
import { salesPhone } from '../services/defaultProps'

const requestShopSupport = (clientName) => {
  const supportMessage = () => ([
    `Olá. Meu nome é ${clientName} e tenho dúvidas com relação aos meus pedidos. Pode me ajudar?`
  ])

  sendMessageWPP(
    salesPhone,
    supportMessage()
  )
}
class WhatsAppShopDoubt extends Component {
  constructor (props) {
    super(props)
    const { clientName } = this.props
    this.state = { clientName }
  }

  render = () => {
    return (
      <div>
        <div style={{padding: '0px 16px'}}>
          <div className='request-service'>
            <p style={{margin: '4px 0px', fontSize: '16px'}}>
              <img src={WhatsAppIcon} style={{marginLeft: '0px', marginRight: '8px', height: '20px', width: 'auto'}} alt='WhatsApp' />
                Está com alguma dúvida? Entre em contato com a gente pelo WhatsApp clicando
              <span className='link' onClick={() => requestShopSupport(this.state.clientName)}>
                {' '}aqui {' '}
              </span>
                ou envie um e-mail para contato@mosty.com.br!
            </p>
          </div>
        </div>
      </div>
    )
  }
}

WhatsAppShopDoubt.propTypes = {
  clientName: PropTypes.string
}

export default withRouter(WhatsAppShopDoubt)



// WEBPACK FOOTER //
// ./src/components/WhatsAppShopDoubt.js